import React from 'react';
import UUID from '@ax2/common/model/UUID';
import styles from '@/styles/components/question-builders/base/List.module.css';
import DragList from '../../drag-and-drop/DragList';
import { removeById, fixOrder } from '@ax2/common/helpers/array';
import {
  TemplateContentElementData,
  TemplateContentElement,
} from './TemplateContentElement';
import _ from 'lodash';

export interface ListOption extends TemplateContentElementData {
  id: UUID;
  order: number;
}

export interface ListData {
  options: ListOption[];
  label?: string;
  typeIcon?: string;
  withTextFieldPlaceholder?: boolean;
  editable: boolean;
  isLocked: boolean;
  showOrder: boolean;
  onNew: () => void;
  onChange: (options: ListOption[]) => void;
}

const itemControl = (option: ListOption) => (
  <TemplateContentElement {...option} key={option.id} />
);

const orderControl = (order: number) => (
  <div className={styles.order}>{`${order + 1}.`}</div>
);

const isSectionLocked = (
  isGlobalLocked: boolean,
  sectionOptions: ListOption[]
) =>
  isGlobalLocked &&
  sectionOptions.length > 0 &&
  _.findIndex(sectionOptions, so => so.templateType === 'template') === -1;

export const List: React.FC<ListData> = props => {
  const isSLocked = isSectionLocked(props.isLocked, props.options);
  return (
    <div className={styles.listContainer}>
      {props.label && <span className={styles.label}>{props.label}</span>}
      <DragList
        cards={props.options.map(opt => ({
          itemControl: (props.editable && itemControl(opt)) || undefined,
          orderControl: props.showOrder ? orderControl : undefined,
          dragZone: isSLocked ? 'none' : 'icon',
          typeIcon: props.typeIcon,
          withTextFieldPlaceholder: props.withTextFieldPlaceholder,
          isEditable: opt.templateType === 'template',
          itemFrame: 'border',
          item: opt,
        }))}
        limit={8}
        addAction={
          isSLocked
            ? undefined
            : {
                onAdd: props.onNew,
              }
        }
        removeAction={
          isSLocked
            ? undefined
            : {
                onRemove: item => {
                  const opts = removeById(props.options, item.id);
                  props.onChange(fixOrder(opts));
                },
              }
        }
        onComplete={data => props.onChange(fixOrder(data.map(d => d.item)))}
      />
    </div>
  );
};
